import { render, staticRenderFns } from "./MenuPesananComponent.vue?vue&type=template&id=d0d85642&"
import script from "./MenuPesananComponent.vue?vue&type=script&lang=js&"
export * from "./MenuPesananComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports